import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import FormSection from '../controls/FormSection';
import FormFieldRenderer from './FormFieldRenderer';
import { DEFAULT_FIELD_GRID } from './formFieldTypes';

function getVisibleFields(fields, values) {
  return (fields || []).filter((field) => (field.visible ? field.visible(values) : true));
}

function renderFieldGrid({
  fields,
  values,
  errors,
  onFieldChange,
  disabled,
  renderField,
  gridSpacing,
}) {
  const visibleFields = getVisibleFields(fields, values);

  if (!visibleFields.length) {
    return null;
  }

  return (
    <Grid container spacing={gridSpacing}>
      {visibleFields.map((field) => {
        const grid = field.grid || DEFAULT_FIELD_GRID;

        return (
          <Grid item key={field.name || field.id} {...grid}>
            <Box data-form-field={field.name}>
              <FormFieldRenderer
                field={field}
                values={values}
                errors={errors}
                onFieldChange={onFieldChange}
                disabled={disabled}
                renderField={renderField}
              />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}

/**
 * Schema-driven form body — flat field list or grouped sections.
 * Validation and submit logic stay in the feature layer.
 */
export default function FormBuilder({
  layout = 'flat',
  fields = [],
  sections = [],
  values = {},
  errors = {},
  onFieldChange,
  disabled = false,
  gridSpacing = 3,
  renderField,
}) {
  if (layout === 'sections') {
    return (
      <Stack spacing={3}>
        {sections.map((section) => (
          <FormSection
            key={section.id}
            title={section.title}
            description={section.description}
            variant={section.variant || 'card'}
            icon={section.icon}
          >
            {renderFieldGrid({
              fields: section.fields,
              values,
              errors,
              onFieldChange,
              disabled,
              renderField,
              gridSpacing,
            })}
          </FormSection>
        ))}
      </Stack>
    );
  }

  return renderFieldGrid({
    fields,
    values,
    errors,
    onFieldChange,
    disabled,
    renderField,
    gridSpacing,
  });
}
